import { createReducer, on } from '@ngrx/store';
import * as AuthActions from '../auth/auth.actions';
import {
  setCurrencies,
  setDebugInfo,
  setPageFilterCompanyIds,
  toggleDebugInfo,
} from './global.actions';
import { initialGlobalState } from './global.state';

export const globalReducer = createReducer(
  initialGlobalState,
  on(setCurrencies, (state, { currencies }) => ({
    ...state,
    internationalCurrencies: currencies,
  })),
  on(toggleDebugInfo, state => ({
    ...state,
    showDebugInfo: !state.showDebugInfo,
  })),
  on(setDebugInfo, (state, { showDebugInfo }) => ({
    ...state,
    showDebugInfo,
  })),
  on(setPageFilterCompanyIds, (state, { companyIds }) => ({
    ...state,
    pageFilterCompanyIds:
      companyIds === null
        ? null
        : [...new Set((companyIds ?? []).map(id => String(id)).filter(Boolean))].sort(),
  })),
  on(AuthActions.loginSuccess, state => ({ ...state })),
  on(AuthActions.logout, () => ({
    ...initialGlobalState,
  }))
);
